import { render } from "./shaka.vue?vue&type=template&id=3e82923c"
import script from "./shaka.vue?vue&type=script&lang=js"
export * from "./shaka.vue?vue&type=script&lang=js"

import "./shaka.vue?vue&type=style&index=0&id=3e82923c&lang=css"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__